<template>
  <div class="industry-solutions">
    <!-- 导航栏 -->
    <nav class="nav-bar">
      <div class="logo">
        <span class="logo-symbol"><img src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/sunrise-logo.png" width="60" height="60" alt="小晖智能客服"/></span>
        <span class="logo-text">小晖AI客服平台</span>
      </div>
      <div class="nav-links">
        <a href="/solutions" class="active">行业解决方案</a>
        <a href="/product-intro">产品介绍</a>
        <a href="#">定价策略</a>
        <a href="#">技术博客</a>
        <a href="#">关于我们</a>
        <a href="/login" class="secondary-btn">登录</a>
      </div>
    </nav>
    
    <!-- 网站建设中标识 -->
    <div class="construction-banner">
      <div class="construction-content">
        <span class="construction-icon">🚧</span>
        <span class="construction-text">网站建设中，敬请期待</span>
      </div>
    </div>

    <!-- 页面主要内容 -->
    <main class="main-content">
      <!-- 二级菜单包装器 -->
      <div class="secondary-nav-wrapper" ref="secondaryNavWrapper">
        <!-- 二级菜单 - 添加动态类 -->
        <nav class="secondary-nav" :class="{ 'fixed': isSecondaryNavFixed }" ref="secondaryNav">
          <ul class="industry-menu">
            <li><a href="#micro" :class="{ active: activeTab === 'micro' }" @click.prevent="switchTab('micro')">小微实体专项</a></li>
            <li><a href="#ecommerce" :class="{ active: activeTab === 'ecommerce' }" @click.prevent="switchTab('ecommerce')">电商零售</a></li>
            <li><a href="#service" :class="{ active: activeTab === 'service' }" @click.prevent="switchTab('service')">生活服务</a></li>
            <li><a href="#education" :class="{ active: activeTab === 'education' }" @click.prevent="switchTab('education')">知识教育</a></li>
            <li><a href="#developer" :class="{ active: activeTab === 'developer' }" @click.prevent="switchTab('developer')">个人开发者</a></li>
            <li><a href="#other" :class="{ active: activeTab === 'other' }" @click.prevent="switchTab('other')">其他行业</a></li>
          </ul>
        </nav>
        <!-- 占位符，高度与二级菜单相同 -->
        <div class="nav-placeholder" :style="{ height: placeholderHeight + 'px' }"></div>
      </div>
      
      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 小微实体专项 -->
        <section id="micro" class="industry-section" v-if="activeTab === 'micro'">
          <h2><span class="icon">🌟</span> 小微实体专项方案</h2>
          
          <div class="section-intro">
            <p>专为个人开发者、小微企业、个体工商户、工作室等小规模实体打造的经济型AI客服方案</p>
          </div>

          <div class="feature-block">
            <h3>适用对象</h3>
            <ul class="feature-list">
              <li><strong>个人开发者/自由职业者</strong> - 拥有个人作品集网站、独立开发的App或小程序</li>
              <li><strong>小微企业与初创公司</strong> - 员工数在1-10人，官网是主要获客渠道</li>
              <li><strong>实体小店与工作室</strong> - 咖啡店、瑜伽馆、独立设计师工作室、理发店等</li>
              <li><strong>知识付费与教育工作者</strong> - 独立讲师、小型在线教育平台</li>
            </ul>
          </div>

          <div class="feature-block">
            <h3>核心应用场景</h3>
            <div class="scenario-grid">
              <div class="scenario-card">
                <h4>官网智能客服</h4>
                <p>访客浏览官网时，自动弹出AI客服，回答产品、服务、价格、联系方式等常见问题</p>
                <div class="benefit">价值：捕捉每一个潜在销售线索，避免因无人应答而流失客户</div>
              </div>
              
              <div class="scenario-card">
                <h4>小程序内置助手</h4>
                <p>用户在使用小程序预约服务或购买商品时，解答操作流程和使用规则问题</p>
                <div class="benefit">价值：提升用户体验，减少因困惑导致的卸载或差评</div>
              </div>
              
              <div class="scenario-card">
                <h4>电商自动客服</h4>
                <p>淘宝、微店等店铺买家咨询商品规格、发货时间、退换货政策</p>
                <div class="benefit">价值：自动快速回复高频问题，极大减轻店主客服压力</div>
              </div>
              
              <div class="scenario-card">
                <h4>知识库查询</h4>
                <p>学员或用户需要查询课程资料、会员权益、活动规则等</p>
                <div class="benefit">价值：充当智能"活文档"，用户自然语言提问即可获取答案</div>
              </div>
            </div>
          </div>

          <div class="feature-block">
            <h3>方案优势</h3>
            <div class="advantages">
              <div class="advantage-item">
                <div class="advantage-icon">💸</div>
                <h4>超低成本</h4>
                <p>每月少喝一杯咖啡的价格，即可享受专业AI客服服务</p>
              </div>
              <div class="advantage-item">
                <div class="advantage-icon">⚡</div>
                <h4>快速部署</h4>
                <p>10分钟完成配置，无需技术背景，开箱即用</p>
              </div>
              <div class="advantage-item">
                <div class="advantage-icon">🔄</div>
                <h4>长期试用</h4>
                <p>提供长达一年的免费试用期，充分体验产品功能</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 电商零售行业 -->
        <section id="ecommerce" class="industry-section" v-if="activeTab === 'ecommerce'">
          <h2><span class="icon">🛒</span> 电商零售行业</h2>
          
          <div class="section-intro">
            <p>为中小型电商卖家、微商、社区团购等提供智能客服解决方案</p>
          </div>

          <div class="feature-block">
            <h3>主要功能</h3>
            <ul class="feature-list">
              <li><strong>售前咨询</strong> - 自动回答商品规格、价格、库存、促销活动等问题</li>
              <li><strong>订单管理</strong> - 查询订单状态、物流信息、发货时间</li>
              <li><strong>售后服务</strong> - 解答退换货政策、保修条款、使用问题</li>
              <li><strong>促销活动</strong> - 解释双十一、618等促销规则，引导下单</li>
            </ul>
          </div>

          <div class="feature-block">
            <h3>推荐上传文档</h3>
            <div class="doc-list">
              <span class="doc-tag">商品详情页文案</span>
              <span class="doc-tag">促销活动规则</span>
              <span class="doc-tag">售后服务政策</span>
              <span class="doc-tag">会员权益说明</span>
              <span class="doc-tag">物流配送指南</span>
            </div>
          </div>
        </section>

        <!-- 生活服务行业 -->
        <section id="service" class="industry-section" v-if="activeTab === 'service'">
          <h2><span class="icon">🏪</span> 生活服务行业</h2>
          
          <div class="section-intro">
            <p>为实体店、工作室、服务机构提供7x24小时自动应答服务</p>
          </div>

          <div class="feature-block">
            <h3>适用场景</h3>
            <div class="scenario-list">
              <div class="scenario-item">
                <h4>餐饮店/咖啡馆</h4>
                <p>回答营业时间、菜单价格、预约方式、特色推荐</p>
              </div>
              <div class="scenario-item">
                <h4>美发/美容工作室</h4>
                <p>解答服务项目、价格、预约流程、技师介绍</p>
              </div>
              <div class="scenario-item">
                <h4>健身/瑜伽馆</h4>
                <p>回答课程安排、教练资质、会员价格、体验课预约</p>
              </div>
              <div class="scenario-item">
                <h4>维修/家政服务</h4>
                <p>解释服务范围、收费标准、预约时间、服务流程</p>
              </div>
            </div>
          </div>
        </section>

        <!-- 知识教育行业 -->
        <section id="education" class="industry-section" v-if="activeTab === 'education'">
          <h2><span class="icon">🎓</span> 知识教育行业</h2>
          
          <div class="section-intro">
            <p>为独立讲师、小型教育机构、知识付费作者提供学习支持助手</p>
          </div>

          <div class="feature-block">
            <h3>应用场景</h3>
            <ul class="feature-list">
              <li><strong>课程咨询</strong> - 回答关于课程内容、学费、师资、开课时间的查询</li>
              <li><strong>学习支持</strong> - 为学生提供24/7的学习答疑、资料查找、技术问题解决</li>
              <li><strong>学员管理</strong> - 处理报名、缴费、考试安排、证书查询等行政事务</li>
              <li><strong>资料查询</strong> - 充当智能知识库，快速查找课程资料和学习资源</li>
            </ul>
          </div>
        </section>

        <!-- 个人开发者 -->
        <section id="developer" class="industry-section" v-if="activeTab === 'developer'">
          <h2><span class="icon">💻</span> 个人开发者/创作者</h2>
          
          <div class="section-intro">
            <p>为独立开发者、博主、创作者提供经济高效的客户支持方案</p>
          </div>

          <div class="feature-block">
            <h3>典型用户画像</h3>
            <div class="user-profiles">
              <div class="profile-card">
                <h4>独立App开发者</h4>
                <p>拥有自己的App，需要处理用户反馈、使用问题、功能咨询</p>
                <div class="profile-need">核心需求：降低支持成本，快速响应用户问题</div>
              </div>
              
              <div class="profile-card">
                <h4>技术博主/UP主</h4>
                <p>拥有技术博客或视频频道，粉丝常有技术问题咨询</p>
                <div class="profile-need">核心需求：自动化回答常见技术问题，释放创作时间</div>
              </div>
              
              <div class="profile-card">
                <h4>自由设计师/创作者</h4>
                <p>提供设计服务或销售创意作品，客户咨询项目报价、交付时间</p>
                <div class="profile-need">核心需求：7x24小时接单咨询，不错过任何商机</div>
              </div>
            </div>
          </div>

          <div class="feature-block">
            <h3>认证说明</h3>
            <div class="notice-box">
              <p>📝 <strong>个人开发者认证</strong>：只需提供个人身份证件及相关证明材料（如软件著作权、应用商店后台截图等），即可完成认证，享受企业级服务。</p>
            </div>
          </div>
        </section>

        <!-- 其他行业 -->
        <section id="other" class="industry-section" v-if="activeTab === 'other'">
          <h2><span class="icon">🏢</span> 其他行业参考</h2>
          
          <div class="section-intro">
            <p>以下行业也可使用小晖AI客服平台，具体方案可咨询定制</p>
          </div>

          <div class="industry-list">
            <div class="industry-item">
              <h4>SaaS/软件行业</h4>
              <p>产品技术支持、用户入门引导、账单与订阅管理</p>
            </div>
            
            <div class="industry-item">
              <h4>医疗健康（非诊断）</h4>
              <p>预约服务、机构信息查询、健康科普问答</p>
              <div class="notice">注：不提供医疗诊断建议</div>
            </div>
            
            <div class="industry-item">
              <h4>政府与公共服务</h4>
              <p>政务咨询、政策解读、办事流程指南</p>
            </div>
          </div>
        </section>

        <!-- CTA区域 -->
        <section class="cta-section">
          <div class="cta-content">
            <h3>立即开始您的AI客服之旅</h3>
            <p>选择适合您业务场景的方案，10分钟快速部署，享受7x24小时智能客服</p>
            <div class="cta-buttons">
              <a href="/register" class="primary-btn">免费试用一年</a>
              <a href="/chat" class="secondary-btn">在线咨询方案</a>
            </div>
            <p class="cta-note">小微企业、个体工商户、个人开发者专属优惠方案咨询</p>
          </div>
        </section>
      </div>
    </main>

    <!-- 备案信息页脚 -->
    <footer class="site-footer">
      <div class="footer-content">
        <p>
          © 2026 北京启明晨晖信息技术有限公司 版权所有
          <br/>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">
            京ICP备2026004802号-1
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'IndustrySolutions',
  data() {
    return {
      activeTab: 'micro',
      isSecondaryNavFixed: false,
      placeholderHeight: 0,
      scrollThreshold: 140,
    }
  },
  mounted() {
    if (this.$route.hash) {
      const tab = this.$route.hash.replace('#', '');
      if (['micro', 'ecommerce', 'service', 'education', 'developer', 'other'].includes(tab)) {
        this.activeTab = tab;
      }
    }
    
    this.$nextTick(() => {
      if (this.$refs.secondaryNav) {
        this.placeholderHeight = this.$refs.secondaryNav.offsetHeight;
      }
    });
    
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    switchTab(tabName) {
      this.activeTab = tabName;
      window.history.replaceState(null, null, `#${tabName}`);
      
      if (window.innerWidth < 768) {
        const contentArea = document.querySelector('.content-area');
        if (contentArea) {
          const top = contentArea.offsetTop - 100;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }
    },
    
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > this.scrollThreshold) {
        if (!this.isSecondaryNavFixed) {
          this.isSecondaryNavFixed = true;
        }
      } else {
        if (this.isSecondaryNavFixed) {
          this.isSecondaryNavFixed = false;
        }
      }
    },
    
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.secondaryNav) {
          this.placeholderHeight = this.$refs.secondaryNav.offsetHeight;
        }
      });
    }
  }
}
</script>

<style scoped>
/* CSS变量定义 */
.industry-solutions {
  --space-blue: #0A1A35;
  --tech-blue: #1A4B8C;
  --ai-purple: #00B4FF;
  --electric-blue: #00B4FF;
  --light-bg: #F0F4F9;
  --pure-white: #FFFFFF;
  
  font-family: 'Alibaba PuHuiTi', 'Microsoft YaHei', sans-serif;
  min-height: 100vh;
  background: #ffffff;
}

/* ========== 导航栏样式 ========== */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(10, 26, 53, 0.95);
  backdrop-filter: blur(8px);
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 80px;
  padding: 15px max(20px, env(safe-area-inset-right)) 15px max(20px, env(safe-area-inset-left));
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-text {
  color: white;
  font-weight: bold;
  font-size: 1.3rem;
  white-space: nowrap;
}

.nav-links a {
  margin: 0 15px;
  text-decoration: none;
  color: white;
  position: relative;
  font-weight: 500;
  transition: all 0.3s;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-right: 20px;
  flex-wrap: nowrap;
}

.nav-links a:hover {
  color: #00B4FF;
}

.nav-links a:hover::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--ai-purple);
  animation: underline 0.3s forwards;
}

@keyframes underline {
  from { width: 0; }
  to { width: 100%; }
}

.nav-links a.active::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #057FDB;
}

.nav-links .secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid #057FDB;
  padding: 8px 20px;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s;
  margin-left: 10px;
  text-decoration: none;
}

.nav-links .secondary-btn:hover {
  background: rgba(5, 127, 219, 0.1);
  transform: translateY(-2px);
}

/* ========== 网站建设条 ========== */
.construction-banner {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  background: #f0f7ff;
  color: #4a6fa5;
  text-align: center;
  padding: 6px 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.2;
  border-bottom: 2px solid #d1e3ff;
  box-sizing: border-box;
  z-index: 999;
  box-shadow: 0 3px 3px rgba(207, 189, 184, 0.3);
}

.construction-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* ========== 主要内容区域 ========== */
.main-content {
  max-width: 1200px;
  margin: 140px auto 0;
  padding: 0 20px;
}

/* 页面标题 */
.page-header {
  text-align: center;
  margin-bottom: 10px;
  padding: 20px 0;
  border-bottom: 1px solid #eaeaea;
}

.page-header h1 {
  font-size: 2.2rem;
  color: #0A1A35;
  margin-bottom: 10px;
}

.page-header .subtitle {
  font-size: 1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* ========== 二级菜单包装器 ========== */
.secondary-nav-wrapper {
  position: relative;
  margin-bottom: 20px;
}

/* 二级菜单 - 默认状态 */
.secondary-nav {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px 15px;
  z-index: 98;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #057FDB;
  transition: all 0.3s ease;
}

/* 二级菜单 - 固定状态 */
.secondary-nav.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-top: none;
  padding: 8px 0;
  background: rgba(248, 249, 250, 0.95);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease;
  z-index: 999;
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 固定状态下，二级菜单居中显示 */
.secondary-nav.fixed .industry-menu {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.industry-menu {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: center;
}

.industry-menu li a {
  display: block;
  padding: 6px 12px;
  background: white;
  color: #555;
  text-decoration: none;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  font-weight: 500;
  font-size: 0.9rem;
  white-space: nowrap;
  line-height: 1.2;
}

.industry-menu li a:hover {
  border-color: #057FDB;
  color: #057FDB;
  transform: translateY(-1px);
}

.industry-menu li a.active {
  background: #057FDB;
  color: white;
  border-color: #057FDB;
  box-shadow: 0 3px 8px rgba(5, 127, 219, 0.3);
  font-weight: 600;
}

/* 占位符 */
.nav-placeholder {
  visibility: hidden;
  transition: height 0.3s ease;
}

/* ========== 内容区域 ========== */
.content-area {
  margin-top: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 30px;
  margin-bottom: 60px;
  scroll-margin-top: 160px;
}

/* 行业章节 */
.industry-section {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.industry-section h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.industry-section h2 .icon {
  font-size: 2rem;
}

.section-intro {
  background: #F0F8FF;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  border-left: 4px solid #057FDB;
}

.section-intro p {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
}

/* 功能块 */
.feature-block {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #eee;
}

.feature-block:last-child {
  border-bottom: none;
}

.feature-block h3 {
  font-size: 1.4rem;
  color: #0A1A35;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

/* 列表样式 */
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  padding: 12px 0;
  padding-left: 30px;
  position: relative;
  color: #444;
  border-bottom: 1px dashed #eee;
}

.feature-list li:last-child {
  border-bottom: none;
}

.feature-list li::before {
  content: "•";
  color: #057FDB;
  font-size: 1.5rem;
  position: absolute;
  left: 0;
  top: 10px;
}

.feature-list li strong {
  color: #0A1A35;
}

/* 场景网格 */
.scenario-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.scenario-card {
  background: white;
  border: 1px solid #e8f0fe;
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s;
}

.scenario-card:hover {
  border-color: #057FDB;
  box-shadow: 0 8px 16px rgba(5, 127, 219, 0.1);
}

.scenario-card h4 {
  color: #057FDB;
  margin-bottom: 10px;
  font-size: 1.1rem;
}

.scenario-card p {
  color: #666;
  margin-bottom: 15px;
  font-size: 0.95rem;
  line-height: 1.5;
}

.scenario-card .benefit {
  background: #F0F8FF;
  padding: 10px;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #4a6fa5;
  border-left: 3px solid #057FDB;
}

/* 优势展示 */
.advantages {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.advantage-item {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.advantage-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.advantage-item h4 {
  color: #0A1A35;
  margin-bottom: 10px;
}

.advantage-item p {
  color: #666;
  font-size: 0.95rem;
  margin: 0;
}

/* 文档标签 */
.doc-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

.doc-tag {
  background: #E8F5E9;
  color: #2E7D32;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  border: 1px solid #C8E6C9;
}

/* 用户画像 */
.user-profiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.profile-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
}

.profile-card h4 {
  color: #0A1A35;
  margin-bottom: 10px;
}

.profile-card p {
  color: #666;
  margin-bottom: 15px;
  font-size: 0.95rem;
}

.profile-card .profile-need {
  background: #FFF3E0;
  padding: 10px;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #E65100;
  border-left: 3px solid #FF9800;
}

/* 通知框 */
.notice-box {
  background: #FFF3E0;
  border: 1px solid #FFE0B2;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
}

.notice-box p {
  margin: 0;
  color: #E65100;
}

/* 行业列表 */
.industry-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.industry-item {
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.industry-item h4 {
  color: #0A1A35;
  margin-bottom: 10px;
}

.industry-item p {
  color: #666;
  margin-bottom: 10px;
}

.industry-item .notice {
  font-size: 0.85rem;
  color: #F57C00;
  font-style: italic;
}

/* ========== CTA区域 ========== */
.cta-section {
  background: linear-gradient(135deg, #0A1A35, #162B50);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  color: white;
  margin-top: 40px;
}

.cta-content h3 {
  font-size: 1.8rem;
  margin-bottom: 15px;
  color: white;
}

.cta-content p {
  opacity: 0.9;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.primary-btn {
  background: #057FDB;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.primary-btn:hover {
  background: #0468b7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(5, 127, 219, 0.3);
}

.secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 10px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  font-size: 1rem;
}

.secondary-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.cta-note {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-top: 20px;
}

/* ========== 页脚 ========== */
.site-footer {
  background: #f5f5f5;
  border-top: 1px solid #eee;
  padding: 30px 5%;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
}

.footer-content p {
  margin: 0;
  line-height: 1.6;
}

.site-footer a {
  color: #666;
  text-decoration: none;
  font-family: 'Courier New', Courier, monospace;
}

.site-footer a:hover {
  color: #1296db;
  text-decoration: underline;
}

/* ========== 响应式设计 ========== */
@media (max-width: 768px) {
  .secondary-nav {
    padding: 8px 10px;
  }
  
  .secondary-nav.fixed {
    padding: 6px 0;
  }
  
  .secondary-nav.fixed .industry-menu {
    padding: 0 15px;
  }
  
  .industry-menu {
    gap: 4px;
  }
  
  .industry-menu li a {
    padding: 5px 8px;
    font-size: 0.85rem;
    border-radius: 4px;
  }
  
  .nav-placeholder {
    height: 45px;
  }
  
  .main-content {
    margin-top: 130px;
    padding: 0 15px;
  }
  
  .page-header {
    padding: 15px 0;
    margin-bottom: 8px;
  }
  
  .page-header h1 {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .secondary-nav.fixed {
    padding: 5px 0;
  }
  
  .secondary-nav.fixed .industry-menu {
    padding: 0 10px;
  }
  
  .industry-menu {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 5px;
  }
  
  .industry-menu li a {
    white-space: nowrap;
    font-size: 0.8rem;
  }
  
  /* 隐藏滚动条但保持滚动功能 */
  .industry-menu::-webkit-scrollbar {
    display: none;
  }
  .industry-menu {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  .main-content {
    margin-top: 120px;
  }
  
  .scenario-grid,
  .advantages,
  .user-profiles,
  .industry-list {
    grid-template-columns: 1fr;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}

/* 当二级菜单固定时，调整主内容的margin-top */
.secondary-nav.fixed + .nav-placeholder {
  margin-bottom: 10px;
}
</style>